import ApiClient, {requestRemoteData} from '../../API/api';

const GET_ADDRESSES_ENDPOINT = 'account/address';
const SET_DEFAULT_DELIVERY_ADDRESS_ENDPOINT = 'account/address/:addressId/delivery'
const GET_DELIVERY_ADDRESSES_ENDPOINT = 'account/address/delivery';

/**
 * En modo comercial, con el cliente representado devuelve las direcciones de ese cliente.
 * @returns {Promise<Array<Address>>}
 */
export const fetchAddresses = (actingAsNumCliente = null) => {
  const headers = actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {};
  return ApiClient.performRequest(GET_ADDRESSES_ENDPOINT, { headers });
}

/**
 * @param addressId
 * @returns {Promise<*>}
 */
export const setDefaultDeliveryAddress = (addressId) => {
  return ApiClient.performRequest(SET_DEFAULT_DELIVERY_ADDRESS_ENDPOINT, {
    method: 'PUT',
    pathParams: { addressId }
  });
};

/**
 * @returns {Promise<RemoteData<Address>>}
 */
export const getDeliveryAddresses = (actingAsNumCliente = null) => {
  const headers = actingAsNumCliente ? { 'X-Acting-As-Client': actingAsNumCliente } : {};
  return requestRemoteData(GET_DELIVERY_ADDRESSES_ENDPOINT, { headers });
};
